var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "Icn/Edit/White");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.249642 0.20290099 10.59885 0.20290099 10.59885 10.4495347 0.249642 10.4495347"
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Icn/Edit/White",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(16.200000, 0.064533)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.367892,4.46729703 C10.675962,5.21153465 10.675962,5.77532673 10.367892,6.156 L5.973642,10.4495347 L0.249642,4.78220792 L4.643622,0.431465347 C4.990842,0.126445545 5.540022,0.126445545 6.291702,0.431465347 C7.043382,0.737287129 7.842852,1.29011881 8.691192,2.09183168 C9.500652,2.93150495 10.058742,3.72305941 10.367892,4.46729703",
  id: "Fill-1",
  fill: "#ED1C23",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.052788,7.6232495 C24.418638,8.48190297 24.408648,9.12161584 24.023898,9.54105149 L19.571598,13.9487347 L12.980358,7.42302178 L17.432388,3.01480396 C17.856288,2.63386337 18.502128,2.62397228 19.369368,2.9862 C20.236608,3.3492297 21.151908,3.98814059 22.115808,4.90400198 C23.040828,5.85835842 23.685858,6.76459604 24.052788,7.6232495",
  id: "Fill-4",
  fill: "#BEBBAE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.770198,25.0547703 L0.780678,26.7718099 C0.471798,26.847998 0.221508,26.7525624 0.028998,26.4857703 C-0.009612,26.2943644 -0.009612,26.1422554 0.028998,26.0278396 L1.763748,22.0778198 C2.032938,21.5054733 2.447658,21.1143743 3.006828,20.9042554 C3.565188,20.6949386 4.143258,20.7139188 4.741308,20.9614634 C5.338548,21.2100772 5.743278,21.6108 5.955498,22.163899 C6.166908,22.7175327 6.148008,23.2799881 5.897718,23.8523347 C5.646618,24.4249485 5.270778,24.8256713 4.770198,25.0547703",
  id: "Fill-6",
  fill: "#2B2622"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.956924,22.4786228 C10.647774,22.6315337 9.375804,23.0795733 7.140744,23.8238109 C4.904874,24.5677812 3.362634,24.7300485 2.515374,24.3103455 C2.090934,23.4714743 2.255094,21.944504 3.006774,19.7307713 C3.758454,17.5178406 4.210974,16.2584644 4.365414,15.9523752 L14.772834,5.64826634 L14.888394,5.5338505 C15.312294,5.26732574 15.948144,5.32453366 16.796484,5.70547426 C17.644014,6.08748416 18.511254,6.71703861 19.398204,7.59440495 C20.284614,8.47284059 20.920734,9.33176139 21.306294,10.1706327 C21.691044,11.0105733 21.749094,11.6401277 21.479904,12.0598307 L21.421854,12.0598307 L10.956924,22.4786228",
  id: "Fill-8",
  fill: "#FFD36A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.365468,15.9524822 L4.134348,17.3837495 C4.134348,17.6510762 4.249908,17.7844723 4.481298,17.7844723 L5.521878,17.6125812 C5.753268,17.6125812 5.868828,17.726997 5.868828,17.956096 L5.753268,19.1010564 C5.753268,19.3301554 5.887728,19.4445713 6.157728,19.4445713 L7.198578,19.2726802 C7.429968,19.2726802 7.545528,19.3873634 7.545528,19.616195 L7.371918,20.6467396 C7.371918,20.8758386 7.487748,20.9899871 7.718868,20.9899871 L8.875278,20.8758386 C9.106668,20.8758386 9.222228,20.9899871 9.222228,21.2190861 L9.106668,22.4212545 C9.106668,22.6503535 9.222228,22.7647693 9.453618,22.7647693 L10.956978,22.5356703 L2.515428,26.0277594 C2.784618,25.6075218 2.659878,25.1493238 2.139318,24.6539673 C1.619298,24.1583436 1.165698,24.0439277 0.780678,24.3104525 L4.365468,15.9524822",
  id: "Fill-10",
  fill: "#E4A96E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.793821,16.2387891 C6.716331,16.3155119 6.620481,16.353205 6.504921,16.353205 C6.427161,16.353205 6.331311,16.3155119 6.215751,16.2387891 C6.061311,16.0481851 6.061311,15.8575812 6.215751,15.6661752 L14.946201,7.07937327 C15.138711,6.92726436 15.322041,6.92726436 15.495651,7.07937327 C15.668991,7.23228416 15.678171,7.40390792 15.524541,7.59451188 L6.793821,16.2387891 Z M9.048861,18.4712347 L17.721531,9.82722475 C17.875161,9.63662079 17.875161,9.45510594 17.721531,9.28321485 C17.567091,9.11159109 17.393751,9.10250198 17.201241,9.25461089 L8.470521,17.8988881 C8.316081,18.0902941 8.316081,18.2806307 8.470521,18.4712347 C8.547471,18.5097297 8.634141,18.5284426 8.730801,18.5284426 C8.826651,18.5284426 8.933301,18.5097297 9.048861,18.4712347 L9.048861,18.4712347 Z M11.246121,20.6467396 L19.976301,12.0027297 C20.130201,11.8118584 20.121021,11.6402347 19.947681,11.4873238 C19.774071,11.3352149 19.590741,11.3352149 19.398231,11.4873238 L10.667511,20.0741257 C10.513341,20.2655317 10.513341,20.4561356 10.667511,20.6467396 C10.783341,20.7234624 10.889181,20.7611554 10.985841,20.7611554 C11.081421,20.7611554 11.168091,20.7234624 11.246121,20.6467396 L11.246121,20.6467396 Z",
  id: "Fill-12",
  fill: "#FBB435"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.2d9d45e9.svg";
export { ForwardRef as ReactComponent };